export const commonFigureStyles = (FOUNDATIONS) => ({
    margin: '0',
    position: 'relative',
    width: '100%',
    height: '100%',
});
export const commonContainerStyles = (FOUNDATIONS) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
});
export const commonImageStyles = (FOUNDATIONS) => ({
    width: '100%',
    height: '100%',
});
export const commonContentContainerStyles = (FOUNDATIONS) => ({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
});
export const commonStateStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    figure: {
        ...commonFigureStyles(FOUNDATIONS),
        ...STATE_TOKENS?.figure,
    },
    imageContainer: {
        ...commonContainerStyles(FOUNDATIONS),
        ...STATE_TOKENS?.imageContainer,
    },
    image: {
        ...commonImageStyles(FOUNDATIONS),
        ...STATE_TOKENS?.image,
    },
    contentContainer: {
        ...commonContentContainerStyles(FOUNDATIONS),
        ...STATE_TOKENS?.contentContainer,
    },
});
//# sourceMappingURL=commonStyles.js.map